import { Component, OnInit,ViewChild, ɵConsole } from '@angular/core';
import swal from 'sweetalert2'; 
import { SelectItem } from 'primeng/api';
import { AuthService } from 'src/app/services/auth.service';
import * as _ from 'underscore';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {MenuItem} from 'primeng/api';
import * as fs from 'file-saver';
import { Workbook } from 'exceljs';
//import { DeprecatedI18NPipesModule } from '@angular/common';

import { PdfMakeWrapper, Img } from 'pdfmake-wrapper';
import { Txt, Columns, Table, Ul, Ol } from 'pdfmake-wrapper';

import pdfMake  from 'pdfmake/build/pdfmake';
import * as moment from 'moment';

import { TreeNode } from "primeng/api";

export interface NewTreeNode extends TreeNode {
  visible?: boolean;
  children?: NewTreeNode[];
}

@Component({
  selector: 'app-frmmatpuecur',
  templateUrl: './frmmatpuecur.component.html',
  styleUrls: ['./frmmatpuecur.component.scss']
})
export class FrmmatpuecurComponent implements OnInit {
  @ViewChild('closeCurso', {static: false}) closeCurso; 
  @ViewChild('closePuesto', {static: false}) closePuesto; 

  @ViewChild('closemat', {static: false}) closemat; 
  @ViewChild('btnnewmat', {static: false}) btnnewmat; 

  @ViewChild('closeabr', {static: false}) closeabr; 
  @ViewChild('btnvermat', {static: false}) btnvermat; 
  
  
  
  loading: boolean = false;
  usu;

  options: NewTreeNode[];

  vcur;
  vpue;
  est; selest

  selectedFile: TreeNode;
  items1: MenuItem[];

  bnvo:boolean= false;

  constructor(
    public authService: AuthService,
    public router: Router,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    /*
    this.items1 = [
      {label: 'Nueva matriz', icon: 'pi pi-plus', command: (event) => this.newMat(this.selectedFile)},      
      {label: 'ver matrices', icon: 'pi pi-eye', command: (event) => this.newMat(this.selectedFile)},      
    ];*/

    this.id_cliente=Number(localStorage.getItem("id_cliente"));

    this.items1 = [
      {label: 'Nueva matriz', icon: 'pi pi-plus', command: (event) => this.newMat(this.selectedFile)},     
      {label: 'Ver matrices', icon: 'pi pi-eye', command: (event) => this.verMat(this.selectedFile)},             
    ];

    //this.usu = this.authService.leerUsuario()    
    this.usu = 0
    if (this.usu != null){            
      
      this.ls_listadoestaciones();                 
      
      this.ls_puestos();
    }else{
      this.router.navigate(['/login']);
    }
  }
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  
  org;
  nodes: any;  
  id_cliente;
  ls_puestos(){  
    this.id_cliente=Number(localStorage.getItem("id_cliente"));
    
    this.loading =  true;
    var sqry;
    sqry = " select" +
            " id,idarea1 as id_ant,titulo as nombre," +
            " ( select count(*) from tblencrequisito" +
            "  where tblexperiencia_tl.id = tblencrequisito.idexperiencia" +
            " and estado = 'A'" +
            " ) as total" +
            " from tblexperiencia_tl"+
            " where id_cliente = " + this.id_cliente +
            " and estatus = 'A'";

    this.authService.ejecuta1(sqry)
    .then(
      data  => { 
        this.loading =  false;       
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);      
        if (res.length!=0){
          var _vec = [];
          _vec.push({ 
            id: 0, 
            id_ant: -1, 
            nombre: "Estructura organizacional", 
            total: 0
          });    
          for(var i = 0; i < res.length;i++){
            _vec.push({ 
              id: res[i].id, 
              id_ant: res[i].id_ant, 
              nombre: res[i].nombre, 
              total: res[i].total,
            });                         
          }
          this.org = _vec

          for(let i=0;i<this.org.length;i++){
            if(this.org[i].id==0){

              this.nodes=[{
                label: this.org[i].nombre,
                total: this.org[i].total,
                data: this.org[i].id,
                dataA: this.org[i].id_ant,
                children:this.get_nodes(this.org[i].id)
                }];
            }
          }

          this.options = this.nodes ;
          this.options = this.getValidTreeNodeItems(this.options);

        }
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }
  get_nodes(id){
    var child:any=[];
    for(var x=0;x<this.org.length;x++){
      if (this.org[x].id_ant==id){
        child.push({
          label: this.org[x].nombre,
          total: this.org[x].total,
          data: this.org[x].id,
          dataA: this.org[x].id_ant,          
          children:this.get_nodes(this.org[x].id)
        });
      }
    }
    return child;
  }
  
  getValidTreeNodeItems(treeNodes: NewTreeNode[]): NewTreeNode[] {
    const validItem = treeNodes.filter(i => i.visible !== false);

    validItem.forEach(i => {
      if (i.children) {
        i.children = this.getValidTreeNodeItems(i.children);
      }
    });
    return validItem;
  }
 

  ls_listadoestaciones(){
    var sqry;    
    sqry = " select" +
           " id,nombre" +
           " from tblestacion" +
           " where estado <> 'C'" +           
           " order by nombre";

    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0)
          {
            var _est = [];            
            for(var i = 0; i < res.length;i++){
              _est.push({ id: res[i].id, nombre: res[i].nombre, });
            }
            this.est = _est;                           
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }
  
  ls_listadocursos(id){
    var sqry;    
    sqry = " select" +
           " tblcurso.id,tblcurso.clave,tblcurso.nombre,tblcurso.descripcion," +
           " tblcategoria_ent.nombre as categoria,tblcategoria_ent.color" +
           " from tblcurso,tblcategoria_ent" +
           " where tblcurso.id in (" +           
                          " select idcurso from tbldetrequisito" +
                          " where idencrequisito = " + id +
                          ")" +
           " and tblcurso.idcategoria = tblcategoria_ent.id" +
           " order by tblcurso.nombre";       

    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0)
          {
            var _cur = [];            
            for(var i = 0; i < res.length;i++){
              _cur.push({ 
                id: res[i].id, 
                clave: res[i].clave, 
                nombre: res[i].nombre, 
                descripcion: res[i].descripcion,
                categoria: res[i].categoria,
                color: res[i].color
              });
            }
            _cur = _.sortBy(_cur, 'categoria');
            this.vcur = _cur;  
          }          
          this.ls_listadopuestos(id);      
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }

  
  ls_listadopuestos(id){
    var sqry;    
    sqry = " select" +
           " id,nombre,descripcion" +
           " from tblpuesto" +
           " where estado <> 'C'" +           
           " order by nombre";

    sqry = " select" +
           " tblexperiencia_tl.id,nombre,apaterno,amaterno,titulo" +
           " from tblexperiencia_tl,tblpersona_tl" +
           " where tblexperiencia_tl.id_persona = tblpersona_tl.id" +
           " and tblexperiencia_tl.id in (" +
                                          " select idexperiencia from tbldetrequisito" +
                                          " where idencrequisito = "+ id +
                                          ")";
    
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0)
          {
            var _pue = [];            
            for(var i = 0; i < res.length;i++){
              _pue.push({ 
                id: res[i].id, 
                nombre: res[i].nombre + " " + res[i].apaterno + " " + res[i].amaterno, 
                puesto: res[i].titulo
                });
            }
            this.vpue = _pue;                           
            this.ls_matriz(id);
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }

  vmat;
  cabecera;
  ls_matriz(id){
    var sqry;    
    sqry = " select" +           
      " tblcurso.id as idcurso, tblpuesto.id as idpuesto,IFNULL(tblpuestocurso.id,0) as id" +           
      " from tblcurso" +           
      " join tblpuesto" +           
      " left join tblpuestocurso on (tblcurso.id = tblpuestocurso.idcurso and tblpuesto.id = tblpuestocurso.idpuesto)"

    sqry = " select" +
           " tbldetrequisito.id,idexperiencia,idcurso,`check`," +
           " tblcategoria_ent.nombre as categoria,tblcategoria_ent.color" +
           " from tbldetrequisito,tblcurso,tblcategoria_ent" +
           " where idencrequisito = " + id +           
           " and idcurso > 0" +
           " and tbldetrequisito.idcurso = tblcurso.id" +
           " and tblcurso.idcategoria = tblcategoria_ent.id";

    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0)
          {
            var _vmat = [];            
            for(var i = 0; i < res.length;i++){
              var bcheck: boolean = false;
              if (res[i].check > 0){
                bcheck = true;
              }
              var colorR = res[i].color;
              colorR = colorR.replace("#", "");
              _vmat.push({ 
                id: res[i].id, 
                idpuesto: res[i].idexperiencia, 
                idcurso: res[i].idcurso, 
                categoria: res[i].categoria, 
                check: bcheck,
                color: res[i].color,                                              
                colorR: colorR,  
              });
            }
            this.vmat = _vmat;   
            
            
            var _cabecera = [];    
            var scategoriaA = ""; var j=0; var scolor=""; var scolor1=""; var scolorR="";
            for(var i = 0; i < this.vcur.length;i++){  
              if (scategoriaA!=""){
                if (this.vcur[i].categoria != scategoriaA){
                  _cabecera.push({colspan:j,name: scategoriaA, color: scolor, color1: scolor1, colorR: scolorR});              
                  j=0;
                }
              }
              scolorR = res[i].color;
              scolorR = scolorR.replace("#", "");
  
              scategoriaA = this.vcur[i].categoria;            
              scolor = this.vcur[i].color + "60";
              scolor1 = this.vcur[i].color;
              j = j + 1;
            }
            _cabecera.push({colspan:j,name: scategoriaA, color: scolor, color1: scolor1, colorR: scolorR});                 
            this.cabecera = _cabecera;

            this.bnvo = true;            
          }else{
            this.bnvo = true;             
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }


  toggleVisibility(eve,itm){
    var sqry;
    if (eve.checked){
      sqry = " update tbldetrequisito set" +
             " `check` = 1 where id = " + itm.id;
    }else{
      sqry = " update tbldetrequisito set" +
             " `check` = 0 where id = " + itm.id;
    }    
    this.loading = true;
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.ls_listadopuestos(this.itmmat.id);      
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }

  ls_selest(){   

  }


  itm = {
    id:0,
    clave:"",
    nombre:"",
    descripcion:"",
  }

  cat; selcat;
  cur; selcur;
  ls_nvocurso(){
    this.cat = null;
    this.selcat = null;
    this.cur = null;
    this.selcur = null;
    var sqry;   
    sqry = " select" +
           " id,nombre" +
           " from tblcategoria_ent" +
           " order by nombre";    
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0){
            var _cat = [];            
            for(var i = 0; i < res.length;i++){
              _cat.push({ id: res[i].id, nombre: res[i].nombre, });
            }
            this.cat = _cat;                           
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }
  ls_selcat(){
    this.cur = null;
    this.selcur = null;
    var sqry;    
    sqry = " select" + 
           " id,nombre" + 
           " from tblcurso" + 
           " where estado = 'A'" + 
           " and id not in (" +
                            " select idcurso from tbldetrequisito" +
                            " where idencrequisito = " + this.itmmat.id +
                            ")" +
           " and idcategoria = " + this.selcat.id +
           " order by nombre";
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat); 

          if (res.length!=0){
            var _cur = [];            
            for(var i = 0; i < res.length;i++){
              _cur.push({ id: res[i].id, nombre: res[i].nombre, });
            }
            this.cur = _cur;                           
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }

  cancelacur(){
    this.closeCurso.nativeElement.click();        
  }
  cancelapue(){
    this.closePuesto.nativeElement.click();        
  }
  
  guardacur(){
    if (this.selcur == null){
      swal.fire('', '<h5>Proporcione el curso</h5>', 'warning');
      return;
    }
    var sqry;
    sqry = " insert into tbldetrequisito (" +
           " idencrequisito,idexperiencia,idcurso,`check`)" +
           " values (" +
           this.itmmat.id + 
           ",(select idexperiencia from tbldetrequisito where idcurso = 0 and idencrequisito = " + this.itmmat.id  + ")," + 
           this.selcur.id + "," +
           "0)";

sqry = " insert into tbldetrequisito" +
" (idencrequisito,idexperiencia,idcurso,`check`)"  +
"select "+ this.itmmat.id  +",a.idexperiencia,"+ this.selcur.id+",0 from tbldetrequisito as a where a.idcurso = 0 and a.idencrequisito = " + this.itmmat.id;


    this.authService.ejecuta1(sqry)
      .then(
        data  => {        
          this.loading =  false;           
          this.closeCurso.nativeElement.click();        
          this.ls_listadocursos(this.itmmat.id);      
          swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });
  }
  

  guardapue(){    
    if (this.itm.nombre == ""){
      swal.fire('', '<h5>Proporcione el nombre</h5>', 'warning');
      return;
    }

    var sqry;
    if (this.itm.id == 0){
      sqry = " insert into tblpuesto (" +
             " nombre,descripcion,estado)" +
             " values ('" +             
             this.itm.nombre + "','" +             
             this.itm.descripcion + "','" +             
             "A" + "')";
    }else{
      sqry = " update tblpuesto set" +             
             " nombre = '" + this.itm.nombre + "'," +             
             " descripcion = '" + this.itm.descripcion + "'" +             
             " where id = " + this.itm.id;
    }
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;           
        this.closePuesto.nativeElement.click();        
        this.ls_listadocursos(this.itmmat.id);      
        if (this.itm.id == 0)
          swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
        else
          swal.fire({ icon: "success", title: "Información modificada", showConfirmButton: false, timer: 1000 });
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }


  cancelamat(){
    this.closemat.nativeElement.click();        
  }


  itmmat = {
    id:0,
    idcliente:0,
    idexperiencia:0,
    nombre:"",   
  }
  
  nodes1: any;  
  idexperiencia = 0;
  newMat(file: TreeNode) {

    this.idexperiencia = file.data;
    this.resultArr1.push(file.data)
    this.searchTree(this.options[0],file.data)

    if (file.data == 0){      
      return;
    }
    this.btnnewmat.nativeElement.click();        

    this.itmmat.id = 0;
    this.itmmat.idcliente = this.id_cliente;
    this.itmmat.idexperiencia = file.data;
    this.itmmat.nombre = "";
  }


  cancelaabr(){
    this.closeabr.nativeElement.click();        
  }

  ls_selmat(itm){
    this.itmmat.id = itm.id;
    this.itmmat.idcliente = itm.idcliente;
    this.itmmat.idexperiencia = itm.idexperiencia;
    this.itmmat.nombre = itm.nombre;
    this.closeabr.nativeElement.click();        
    this.ls_listadocursos(this.itmmat.id);            
  }

  abr;
  verMat(file: TreeNode) {
    var sqry;    
    sqry = " select" + 
           " id,nombre,idexperiencia,idcliente" + 
           " from tblencrequisito" + 
           " where estado = 'A'" + 
           " and idcliente = " + this.id_cliente +
           " and idexperiencia = " + file.data +
           " order by id desc";

    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          this.abr= data;
          this.btnvermat.nativeElement.click();        
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }


   resultArr = [];
   resultArr1 = [];
   searchTree(node, data){    
    if(node.children){
      node.children.forEach( (n) => {        
        if(n.dataA === data){
          this.resultArr.push(n);
          this.resultArr1.push(n.data)
        }
        this.searchTree(n, data);
      })
    } 
    return this.resultArr;   
  }

  guardamat(){
    if (this.itmmat.nombre == ""){
      swal.fire('', '<h4>Proporcione el nombre de la matriz</h4>', 'warning');
      return;
    }
    var sopciones = "";
    for(var i = 0; i < this.resultArr1.length;i++){
      if (i>0){
        sopciones = sopciones + ",";
      }
      sopciones = sopciones +  this.resultArr1[i];
    }


    var sqry;
    sqry = " call spins_tblencrequisito (" +                          
            this.id_cliente + "," +
            this.idexperiencia + ",'" +
            this.itmmat.nombre + "','" +
            sopciones + "')";      

      this.authService.ejecuta1(sqry).then(
          data => {   
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat); 

            this.itmmat.id = res[0][0].id;
            swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
            this.ls_listadocursos(this.itmmat.id);            
      },
      error => {
          this.loading =  false;
          swal.fire('Datos incorrectos', '', 'error');
      });                                                                                                 


  }


  
  exportExcel(){
    const workbook = new Workbook();    
    const worksheet = workbook.addWorksheet("Entrenamiento");
    
    var _cols=[];
    var _cols1=[];

    const header0 = [];
    header0.push("");
    var t=2;
    var ti=0;
    for (let i = 0; i < this.cabecera.length; i++) {      
      for(let j = 0; j < this.cabecera[i].colspan; j++){
        if (j == 0){
          ti = t;
          header0.push(this.cabecera[i].name);           
        }else{
          header0.push("");           
        }
        t = t + 1;        
        _cols1.push({ colorR: this.cabecera[i].colorR });
      }
      _cols.push({ ti: ti, t: t-1 });
    }

    const headerRow0 = worksheet.addRow(header0);  
    //Merge
    for(let i = 0; i<_cols.length; i++){
      worksheet.mergeCells(1,_cols[i].ti,1,_cols[i].t);      
    }

    headerRow0.eachCell((cell, number) => {          
      var number1 = number - 1;        
      var scolor;
      var scolorF = "FFFFFF";
      
      if (number1 == 0){
        scolor = "413f41";
      }else{
        if (number1<this.vcur.length){
          scolor = _cols1[number1].colorR;          
        }else{
          scolor = "fin";
        }
      }
      
      if (scolor!="fin"){          
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: scolor },          
          bgColor: { argb: scolor }
        };
        cell.font = {
          color : { argb: scolorF }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};      
      }
    });


    
    
    


    const header = [];
    header.push("Matriz -" + this.itmmat.nombre);
    for (let i = 0; i < this.vcur.length; i++) {
      header.push(this.vcur[i].curso);           
    }
    
    const headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {        
      var number1 = number - 1;        
      var scolor;
      if (number1 == 0){
        scolor = "413f41";
      }else{
        if (number1<this.vcur.length){
          //scolor = this.vcur[number1].colorR;
          scolor = this.vcur[number1].color;
        }else{
          scolor = "fin";
        }
      }
      if (scolor!="fin"){          
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: scolor },          
          bgColor: { argb: scolor }
        };
        cell.font = {
          color : { argb: 'FFFFFF' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

        
      }
    });

    for (let i = 1; i <= this.vcur.length + 1; i++) {                
      if (i >= 2){
        worksheet.getCell(2,i).alignment = { textRotation: 90, wrapText: true,  horizontal: 'center'};
        //worksheet.getCell(2,i).fill = { type: 'pattern', pattern: 'solid',  fgColor: { argb: this.vcur[i-2].colorR }, bgColor: { argb: this.vcur[i-2].colorR } };
        worksheet.getCell(2,i).fill = { type: 'pattern', pattern: 'solid',  fgColor: { argb: this.vcur[i-2].color }, bgColor: { argb: this.vcur[i-2].color } };
        worksheet.getCell(2,i).font = { color: { argb: 'FFFFFF' }};
      }else{
        worksheet.getCell(2,i).alignment = { wrapText: true,  horizontal: 'center', vertical: 'middle'};
        worksheet.getCell(2,i).font = { bold: true, size: 16, color: { argb: 'FFFFFF' } };
      }
    }

    

    //VIGENCIA
    /*
    const header1 = []; 
    header1.push("VIGENCIA");
    for (let i = 0; i < this.Vcurso.length; i++) {
      header1.push(this.Vcurso[i].vigencia + " AÑO(S)");           
    }
    const headerRow1 = worksheet.addRow(header1);
    headerRow1.eachCell((cell, number) => {        
      var number1 = number - 1;        
      var scolor;
      
      if (number1<this.Vcurso.length){
        scolor = "b2b0b7";
      }else{
        scolor = "fin";
      }
      
      if (scolor!="fin"){          
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: scolor },          
          bgColor: { argb: scolor }
        };
        cell.font = {
          color : { argb: 'FFFFFF' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
      }
    });
    for (let i = 2; i <= this.Vcurso.length + 1; i++) {                      
      worksheet.getCell(3,i).fill = { type: 'pattern', pattern: 'solid',  fgColor: { argb: "b2b0b7" }, bgColor: { argb: "b2b0b7" } };
      worksheet.getCell(3,i).font = { color: { argb: 'FFFFFF' }};
    }
    */

    //HORAS
    /*
    const header2 = []; 
    header2.push("HORAS");
    for (let i = 0; i < this.Vcurso.length; i++) {
      header2.push(this.Vcurso[i].horas);           
    }
    const headerRow2 = worksheet.addRow(header2);
    headerRow2.eachCell((cell, number) => {        
      var number1 = number - 1;        
      var scolor;
      
      if (number1<this.Vcurso.length){
        scolor = "b2b0b7";
      }else{
        scolor = "fin";
      }
      
      if (scolor!="fin"){          
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: scolor },          
          bgColor: { argb: scolor }
        };
        cell.font = {
          color : { argb: 'FFFFFF' }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        cell.alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
      }
    });
    for (let i = 2; i <= this.Vcurso.length + 1; i++) {                      
      worksheet.getCell(4,i).fill = { type: 'pattern', pattern: 'solid',  fgColor: { argb: "b2b0b7" }, bgColor: { argb: "b2b0b7" } };
      worksheet.getCell(4,i).font = { color: { argb: 'FFFFFF' }};
    }
    */

    //CONTENIDO
    var w = 5;
    for (let i = 0; i<this.vpue.length; i++) {
      const header3 = []; 
      header3.push(this.vpue[i].nombre);
      for (let j = 0; j < this.vcur.length; j++) {
        header3.push(""); 
      }
      for (let j = 0; j < this.vcur.length; j++) {
        for (let k = 0; k < this.vmat.length; k++) {
          if ( this.vmat[k].idpuesto == this.vpue[i].id && this.vmat[k].idcurso == this.vcur[j].id){
            if (this.vmat[k].check == true){
              header3[j+1] = "X";
            }
          }
        }
      }
      const headerRow3 = worksheet.addRow(header3);   
      headerRow3.eachCell((cell, number) => {    
        var number1 = number - 1;        
        var scolor;
        var scolorF;
        if (number1 == 0){
          scolor = "413f41";
          scolorF = "FFFFFF";
        }else{
          scolor = "FFFFFF";
          scolorF = "FFFFFF";
        }
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: scolor },          
          bgColor: { argb: scolor }
        };
        cell.font = {
          color : { argb: scolorF }
        }
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        if (number1 == 0){
          cell.alignment = { wrapText: true,  horizontal: 'left' , vertical:'middle'};
        }
        else{
          cell.alignment = { wrapText: true,  horizontal: 'center' , vertical:'middle'};
        }        
      });
      w = w + 1;
    }

    for (let i = 1; i <= this.vcur.length + 1; i++) {                
      for (let j = 5; j < w ; j++){
        if (i >= 2){

          if (j % 2) {
            worksheet.getCell(j,i).fill = { type: 'pattern', pattern: 'solid',  
            //fgColor: { argb: this.vcur[i-2].colorR }, bgColor: { argb: this.vcur[i-2].colorR } };
            fgColor: { argb: this.vcur[i-2].color }, bgColor: { argb: this.vcur[i-2].color } };
            worksheet.getCell(j,i).font = { color: { argb: 'FFFFFF' }};
          }else{
            worksheet.getCell(j,i).fill = { type: 'pattern', pattern: 'solid',  
            fgColor: { argb: "FFFFFF" }, bgColor: { argb: "FFFFFF" } };
            worksheet.getCell(j,i).font = { color: { argb: '000000' }};
          }
          
          
        }
      }
    }

    worksheet.getColumn(1).width = 20;


    worksheet.addRow([]);worksheet.addRow([]);worksheet.addRow([]);worksheet.addRow([]);
    w = w + 4;
    
    

    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fs.saveAs(blob, 'Entrenamiento.xlsx');
    });



  }


  regresa(){
    this.bnvo = false;

  }
  

}

